<template>
  <g-container :class="classes">
    <page-content v-if="isUserAgreementAndResetPassword" />
    <template #footer>
      <g-footer @change="onChangeLocale"/>
    </template>
  </g-container>
</template>

<script>
import PageContent from './PageContent.vue'
import { mapActions, mapGetters } from 'vuex'
import GFooter from './components/GFooter'


export default {
  components: {
    PageContent,
    GFooter
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('terms', ['isAgreement', 'isPrivacyPolicy']),
    isUserAgreementAndResetPassword () {
      if (this.isAgreement !== true) {
        return false
      } else if (this.isPrivacyPolicy !== true) {
        return false
      } else if (this.userInfo.passwordChangeDate === 'N') {
        return false
      }
      return true
    },
    classes () {
      if (this.$route.name === 'UserCreateAccount' || this.$route.name === 'ProductEdit' || this.$route.name === 'UserCreateCustomerPortalAccount') {
        return ['user-create-inner-height']
      }
      return ['full-inner-height']
    }
  },
  methods: {
    ...mapActions('locale', ['setLocale']),
    ...mapActions('terms', ['getMyAgreement']),
    onChangeLocale (locale) {
      this.$i18n.locale = locale
      this.setLocale({
        locale
      })
    },
    checkAgreementAndPassword () {
      if (this.isAgreement === false || this.isPrivacyPolicy === false) {
        this.$router.push('/terms/agreement')
      } else if (this.isAgreement === true && this.isPrivacyPolicy === true) {
        if (this.userInfo.passwordChangeDate === 'N') {
          this.$router.push('/login/reset-password')
        }
      }
    }
  },
  watch: {
    isAgreement: {
      handler() {
        this.checkAgreementAndPassword()
      },
      immediate: true
    }
  },
  beforeMount () {
    this.getMyAgreement()
  }
}
</script>

<style scoped>
.full-inner-height, .full-inner-height .container-inner {
  height: calc(100vh - 40px - 70px - 36px) !important
}

.user-create-inner-height, .user-create-inner-height .container-inner {
  height: calc(100vh - 40px - 70px - 36px - 49px) !important
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/PageLayout.vue